import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { createTheme, styled, ThemeProvider } from '@mui/material/styles';
import ModalPopup from '../../../components/formlib/ModalPopup';
import IfspReportMainScreen from '../IfspReportScreens/IfspReportMainScreen';
import { ifspHeartBeat } from '../../../services/ifspClient/IfspApi';
import IfspOutComeMainScreen from '../ifspOutcomesScreens/IfspOutComeMainScreen';
import { IfspSDPAndConsentMainScreen } from '../ifspSDPAndConsentScreens/IfspSDPAndConsentMainScreen';
import IfspTransitionMainScreen from '../ifspTransition/IfspTransitionMainScreen';
import IfspBlankTabScreen from '../ifspComponents/IfspBlankTabScreen';
import { useEffect, useRef, useState } from 'react';
import {
  IfspHeartBeatType,
  updateIfspHeartBeat,
} from '../../../redux/features/ifsp/ifspHeartBeatslice';
import { useIfspUnsavedChanges } from '../ifspUnsavedChanges';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {
  resetIfspDailyRoutineReport,
  setIfspDailyRoutineReport,
} from '../../../redux/features/ifsp/ifspDailyRoutineSlice';
import {
  resetIfspOutcomes,
  setIfspOutcomes,
} from '../../../redux/features/ifsp/ifspOutcomesSlice';
import {
  resetIfspSDPAndConsent,
  setIfspSDPAndConsent,
} from '../../../redux/features/ifsp/ifspSDPAndConsentSlice';
import {
  resetIfspTransition,
  setIfspTransition,
} from '../../../redux/features/ifsp/ifspTransitionSlice';
import { resetIfspUnsavedFields } from '../../../redux/features/ifsp/ifspUnsavedFieldSlice';

export interface IfspTabNavigationComponentType {
  ifspFirstMeetingDate: string;
  openTransitionPlanningTab: boolean;
}

export type IfspHeartBeatReqBodyType = {
  userId: string;
  referralId: string;
  tabName:
    | 'Daily-Routine'
    | 'Family-Concern'
    | 'Developmental-Summary'
    | 'Health-Eligibility'
    | 'Outcome'
    | 'Service'
    | 'Transition'
    | '';
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const CustomTabs = styled(Tabs)({
  '& .MuiButtonBase-root.MuiTab-root': {
    padding: '8px 0px 0px',
    maxWidth: '100%',
    minWidth: 'auto',
    margin: '0px 12px',
    fontFamily: 'Lato-Regular',
    fontStyle: 'normal',
    fontSize: '14px',
    fontWeight: '700',
    textTransform: 'none',
  },
  '&.Mui-selected': {
    color: '#008C82',
    fontFamily: 'Lato-Regular',
    fontWeight: '700',
    fontSize: '14px',
  },
});
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export interface TabProps {
  tabPosition: number;
}

export function TabPanel(props: Readonly<TabPanelProps>) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: '0px 0px' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const IfspTabNavigationComponent = ({
  ifspFirstMeetingDate,
  openTransitionPlanningTab,
}: IfspTabNavigationComponentType) => {
  const [tabPosition, setTabPosition] = useState<number>(
    openTransitionPlanningTab ? 3 : 0,
  );
  const [openUnSavedModal, setOpenUnSavedModal] = useState<boolean>(false);
  const [pendingTabPosition, setPendingTabPosition] = useState<number>(0);
  const tabPositionRef = useRef(tabPosition);
  const dispatch = useAppDispatch();
  const {
    isIfspReportChanged,
    isDevelopmentalSummaryChanged,
    isDevelopmentalSummaryCreatedLocally,
    isFamilyConcernsChanged,
    isFamilyConcernsCreatedLocally,
    isHealthSummaryChanged,
    isHealthSummaryCreatedLocally,
    isDailyRoutineChanged,
    isDailyRoutineCreatedLocally,
    isOutcomeChanged,
    isTransitionChanged,
    isSDPAndConsentChnaged,
    ifspUnsavedFields,
  } = useIfspUnsavedChanges();

  const ifspMainPageDetails = useAppSelector(
    (state) => state.ifspClientDetails.ifspClientDetails,
  );

  const ifspDailyRoutineReportDetails = useAppSelector(
    (state) =>
      state.ifspDailyRoutineReportDetails.originalIfspDailyRoutineReport,
  );
  const ifspOutcomes = useAppSelector((state) => state.ifspOutComes);
  const ifspSDPAndConsent = useAppSelector(
    (state) => state.ifspSDPAndConsent.originalSdpAndConsent,
  );
  const ifspTransition = useAppSelector(
    (state) => state.ifspTransitionDetails.ifspOriginalTransitionData,
  );

  const TabTheme = createTheme({
    components: {
      MuiTabs: {
        styleOverrides: {
          root: {
            marginBottom: '16px',
          },
          indicator: {
            backgroundColor:
              (ifspMainPageDetails.outcomeTbrUpdateRequired &&
                !ifspMainPageDetails.isOutcomeChecked &&
                tabPosition === 1) ||
              (ifspMainPageDetails.serviceDeliveryTbrUpdateRequired &&
                !ifspMainPageDetails.isServiceDeliveryChecked &&
                tabPosition === 2) ||
              (!ifspMainPageDetails.isLocked &&
                tabPosition === 2 &&
                ifspFirstMeetingDate) ||
              (ifspMainPageDetails.transitionTbrUpdateRequired &&
                !ifspMainPageDetails.isTransitionChecked &&
                tabPosition === 3)
                ? '#F96300'
                : '#00C6B8',
            height: '2px',
            bottom: '5%',
          },
        },
      },
    },
  });

  const CustomTab = styled(Tab)(() => ({
    fontFamily: 'Lato-Regular',
    fontWeight: '700',
    fontSize: '14px',

    '&.MuiTab-root': {
      color: '#00C6B8',
    },

    '&.MuiTab-root.Mui-selected': {
      color: '#00C6B8',
    },
  }));

  const ping = React.useCallback(() => {
    const currentTabPosition = tabPositionRef.current;

    let tabName: 'Daily-Routine' | 'Outcome' | 'Service' | 'Transition' | '' =
      '';
    if (currentTabPosition === 1) {
      tabName = 'Outcome';
    } else if (currentTabPosition === 2) {
      tabName = 'Service';
    } else if (currentTabPosition === 3) {
      tabName = 'Transition';
    }

    const referralId = localStorage.getItem('referralId');
    const userId = localStorage.getItem('userId');
    const pingjson = {
      userId: userId ?? '',
      referralId: referralId ?? '',
      tabName: tabName ?? '',
    };
    if (pingjson.tabName)
      ifspHeartBeat(pingjson)
        .then((res: IfspHeartBeatType) => {
          dispatch(updateIfspHeartBeat(res));
        })
        .catch(() => {});
  }, []);

  useEffect(() => {
    tabPositionRef.current = tabPosition;
  }, [tabPosition]);

  useEffect(() => {
    ping();
  }, [tabPosition, ping]);

  useEffect(() => {
    const interval = setInterval(() => {
      ping();
    }, 20000);

    return () => {
      clearInterval(interval);
    };
  }, [ping]);

  const handleChange = (
    _event: React.ChangeEvent<object>,
    position: number,
  ) => {
    if (
      (tabPosition === 0 && isDevelopmentalSummaryCreatedLocally) ||
      (tabPosition === 0 && isFamilyConcernsCreatedLocally) ||
      (tabPosition === 0 && isHealthSummaryCreatedLocally) ||
      (tabPosition === 0 && isDailyRoutineCreatedLocally) ||
      isIfspReportChanged ||
      isDevelopmentalSummaryChanged ||
      isFamilyConcernsChanged ||
      isHealthSummaryChanged ||
      isDailyRoutineChanged ||
      isOutcomeChanged ||
      isTransitionChanged ||
      isSDPAndConsentChnaged ||
      ifspUnsavedFields.isOtherDailyRoutineFieldsChanged ||
      ifspUnsavedFields.isReporterFieldsChanged ||
      ifspUnsavedFields.isServiceDeliveryFieldsChanged ||
      ifspUnsavedFields.isOutComeProgressInfoFieldsChange ||
      ifspUnsavedFields.isHealthAndEligibilityFieldsChanged
    ) {
      setOpenUnSavedModal(true);
      setPendingTabPosition(position);
    } else {
      setTabPosition(position);
      setOpenUnSavedModal(false);
    }
  };

  return (
    <Box>
      <ModalPopup
        open={openUnSavedModal}
        description="UnsavedAlertDescriptionWhileSwitching"
        labelId1="UnSavedAlertCancel"
        labelId2="UnsavedAlertSwitch"
        negativeActionLabel="No"
        positiveActionLabel="Yes"
        onCancel={() => {
          setOpenUnSavedModal(false);
        }}
        onOk={() => {
          dispatch(resetIfspOutcomes());
          dispatch(resetIfspSDPAndConsent());
          dispatch(resetIfspTransition());
          dispatch(resetIfspDailyRoutineReport());
          dispatch(resetIfspUnsavedFields());

          setTabPosition(pendingTabPosition);
          setOpenUnSavedModal(false);
          if (tabPosition === 0) {
            dispatch(setIfspDailyRoutineReport(ifspDailyRoutineReportDetails));
          } else if (tabPosition === 1) {
            dispatch(setIfspOutcomes(ifspOutcomes));
          } else if (tabPosition === 2) {
            dispatch(setIfspSDPAndConsent(ifspSDPAndConsent));
          } else if (tabPosition === 3) {
            dispatch(setIfspTransition(ifspTransition));
          }
        }}
      />
      <ThemeProvider theme={TabTheme}>
        <Box>
          <CustomTabs
            value={tabPosition}
            onChange={handleChange}
            aria-label="secondary tabs example"
          >
            <CustomTab {...a11yProps(0)} label="Report" className="ml-none" />

            <CustomTab
              {...a11yProps(1)}
              label="Outcomes"
              sx={{
                '&.MuiTab-root, &.MuiTab-root.Mui-selected': {
                  color:
                    ifspMainPageDetails.outcomeTbrUpdateRequired &&
                    !ifspMainPageDetails.isOutcomeChecked
                      ? '#F96300'
                      : '#00C6B8',
                },
              }}
            />

            <CustomTab
              {...a11yProps(2)}
              label="Service Delivery"
              sx={{
                '&.MuiTab-root, &.MuiTab-root.Mui-selected': {
                  color:
                    (ifspMainPageDetails.serviceDeliveryTbrUpdateRequired &&
                      !ifspMainPageDetails.isServiceDeliveryChecked) ||
                    (!ifspMainPageDetails.isLocked && ifspFirstMeetingDate)
                      ? '#F96300'
                      : '#00C6B8',
                },
              }}
            />

            <CustomTab
              {...a11yProps(3)}
              label="Transition"
              sx={{
                '&.MuiTab-root, &.MuiTab-root.Mui-selected': {
                  color:
                    ifspMainPageDetails.transitionTbrUpdateRequired &&
                    !ifspMainPageDetails.isTransitionChecked
                      ? '#F96300'
                      : '#00C6B8',
                },
              }}
            />
          </CustomTabs>
          <TabPanel value={tabPosition} index={0}>
            <IfspReportMainScreen />
          </TabPanel>
          <TabPanel value={tabPosition} index={1}>
            {ifspFirstMeetingDate ? (
              <IfspOutComeMainScreen />
            ) : (
              <IfspBlankTabScreen />
            )}
          </TabPanel>
          <TabPanel value={tabPosition} index={2}>
            {ifspFirstMeetingDate ? (
              <IfspSDPAndConsentMainScreen />
            ) : (
              <IfspBlankTabScreen />
            )}
          </TabPanel>
          <TabPanel value={tabPosition} index={3}>
            {ifspFirstMeetingDate ? (
              <IfspTransitionMainScreen />
            ) : (
              <IfspBlankTabScreen />
            )}
          </TabPanel>
        </Box>
      </ThemeProvider>
    </Box>
  );
};

export default IfspTabNavigationComponent;
